import React from "react";
import { Link } from "react-router-dom";
import "./BlogPreview.css";
import { BLOG_POSTS } from "../BlogPages/Blog";

export default function BlogPreview({ limit = 3 }) {
  const posts = BLOG_POSTS.slice(0, limit);

  return (
    <section className="blog-preview">
      <div className="blog-preview-grid">
        {posts.map((post) => (
          <article key={post.id} className="blog-card">
            <Link className="blog-card-link" to={`/blog/${post.slug}`}>
              <div className="blog-card-imageWrap">
                <img
                  className="blog-card-image"
                  src={post.heroImage}
                  alt={post.title}
                  loading="lazy"
                />
              </div>

              <div className="blog-card-body">
                <p className="blog-card-date">{post.date}</p>
                <h3 className="blog-card-title">{post.title}</h3>
                <p className="blog-card-excerpt">{post.excerpt}</p>

                <span className="blog-card-cta">
                  Read More <span aria-hidden="true">→</span>
                </span>
              </div>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}
